// Responsive breakpoints
var smBreakpoint = 768;
var mdBreakpoint = 992;
var lgBreakpoint = 1200;

$(document).ready(function () {
  initVerticalText();
  initNewsletterSection();
  initHeaderScrollEffect();
  initArtworks();
  initNewsSection();
  unifySlides();
  setLinkTargets();


  $(window).on('resize',unifySlides);

  //setTimeout(initLeftCaptchas,500);

  $(document).bind('ajaxComplete',function() {
    $(window).trigger('resize').trigger('scroll');
  })
});
